import React from 'react';
import clsx from 'clsx';
import themePrimary from '../../../styles/themePrimary';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { IconButton, Typography } from '@material-ui/core';
import { Skin } from '../../../models/common/Skin'
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';

const useStyles = makeStyles({
    buttonMainLeft: {
        height: '60px',
        width: '45%',
        borderRadius: '60px',
        float: 'left',
        padding: '3px',
        textAlign: 'center',
        marginLeft: 'auto',
        color: props => (props as Skin).primary_main_color,     
    },
    button: {
        height: '60px',
        width: '45%',
        borderRadius: '60px',
        float: 'left',
        padding: '3px',
        textAlign: 'center',
        marginLeft: 'auto',
        color: themePrimary.palette.primary.contrastText,        
    },
    outerButtonLeft: {
        border: props => '3px solid ' + (props as Skin).primary_main_color,
    },
    outerButtonRight: {
    
    },
    buttonLeft: {
        marginLeft: 'auto',
    },
    buttonRight: {
        marginRight: 'auto',
    },
    buttonIcon:{
        paddingBottom: '15px',
    },
    buttonNoIcon:{

    },
    buttonTextLeft: {
        fontSize: '1.4em',
        lineHeight: '1.2em',
        verticalAlign: 'middle',
        color: props => (props as Skin).primary_main_color,
    },
    buttonTextLeftDisabled: {
        fontSize: '1.4em',
        lineHeight: '1.2em',
        verticalAlign: 'middle',
        color: themePrimary.palette.primary.contrastText + ' !important',
    },
    buttonText: {
        fontSize: '1.4em',
        lineHeight: '1.2em',
        verticalAlign: 'middle',
        color: themePrimary.palette.primary.contrastText,
    },
    icon: {
        height: '30px',
        width: '30px',
        marginRight: '-30px',
        marginLeft: '10px',
    },
    buttonLeftEnabled: {
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
    },
    buttonRightEnabled: {
        backgroundColor: props => (props as Skin).primary_main_color + ' !important',
    },
    buttonLeftDisabled: {
        border: 'none !important',
        backgroundColor: themePrimary.palette.secondary.main + ' !important',
    },
    buttonRightDisabled: {
        backgroundColor: themePrimary.palette.secondary.main + ' !important',
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
    },
    buttonsOuterContainer: {
        display: 'flex',
    },
    buttonInternalContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
    }
});

const SplitButtonInternal = withStyles((themePrimary) => ({
  root: {
    borderRadius: '50px',
    boxShadow: 'none',
    fontSize: themePrimary.typography.h4.fontSize,
    width: '100%',
    height: '100%',
  },
  label: {
      fontSize: '1rem',
  }
}))(IconButton);

export type SplitButtonClickHandler = (event: React.MouseEvent<HTMLElement>) => any;

export interface SplitButtonProps {
    leftLabel: string,
    rightLabel: string,
    leftDisabled: boolean,
    rightDisabled: boolean,
    showIcons: boolean,
    useForwardIcon: boolean,
    useBackIcon: boolean,
    onLeftClickHandler: SplitButtonClickHandler,
    onRightClickHandler: SplitButtonClickHandler,
}

export default function SplitButtons(props: SplitButtonProps) {
    const { leftLabel, rightLabel, leftDisabled, rightDisabled, showIcons, useForwardIcon, useBackIcon, onLeftClickHandler, onRightClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
        <div className={classes.buttonsOuterContainer}>
            <div className={clsx(classes.buttonMainLeft, classes.outerButtonLeft, classes.buttonLeft, {
                        [classes.buttonLeftDisabled]: leftDisabled,
                        [classes.buttonLeftEnabled]: !leftDisabled,
                    })}>
                <SplitButtonInternal
                    disabled={leftDisabled}
                    onClick={onLeftClickHandler}
                    className={clsx(classes.buttonMainLeft, {
                        [classes.buttonNoIcon]: !showIcons,
                        [classes.buttonLeftDisabled]: leftDisabled,
                        [classes.buttonLeftEnabled]: !leftDisabled,
                    })}>
                    {showIcons && useBackIcon &&
                        <ArrowBackIcon className={classes.icon}/>
                    }

                    {showIcons && !useBackIcon &&
                        <CloseIcon className={classes.icon}/>
                    }
                    <div className={classes.buttonContainer}>
                        <div className={classes.buttonInternalContainer}>
                            <span className={clsx({
                                [classes.buttonTextLeftDisabled]: leftDisabled,
                                [classes.buttonTextLeft]: !leftDisabled,
                            })}>{leftLabel}</span>
                        </div>
                    </div>
                </SplitButtonInternal>
            </div>
            <div className={clsx(classes.button, classes.outerButtonRight, classes.buttonRight, {
                        [classes.buttonRightDisabled]: rightDisabled,
                        [classes.buttonRightEnabled]: !rightDisabled,
                    })}>
                <SplitButtonInternal 
                    disabled={rightDisabled}
                    onClick={onRightClickHandler}
                    className={clsx(classes.button, {
                        [classes.buttonNoIcon]: !showIcons,  
                        [classes.buttonRightDisabled]: rightDisabled,
                        [classes.buttonRightEnabled]: !rightDisabled,
                    })}>
                    {showIcons && useForwardIcon &&
                        <ArrowForwardIcon className={classes.icon}/>
                    }

                    {showIcons && !useForwardIcon &&
                        <CheckIcon className={classes.icon}/>
                    }
                    <div className={classes.buttonContainer}>
                        <div className={classes.buttonInternalContainer}>
                            <span className={classes.buttonText}>{rightLabel}</span>
                        </div>
                    </div>
                </SplitButtonInternal>
            </div>
        </div>
    );
}